/* tslint:disable */
export enum Environments {
  Unknown = 'Unknown',
  Development = 'Development',
  Test = 'Test',
  Production = 'Production'
}
